import { render } from "./PixelRequestsCard.vue?vue&type=template&id=4fc438a1"
import script from "./PixelRequestsCard.vue?vue&type=script&lang=js"
export * from "./PixelRequestsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__